import React from "react";
import Sliders from "../utilities/Sliders";

const Features = ({ type, title, des }) => {
  return (
    <section className="w-full h-[800px] pb-20 lg:pb-1 border-b-[1px] border-b-black">
      <div>
        <div className="text-4xl text-red-600 font-DarumadropOne py-1">
          <h3>{type}</h3>
        </div>
        <div className="text-4xl font-FreckleFace capitalize py-1">
          <h1>{title}</h1>
        </div>
        <div className="text-lg text-slate-200 font-Atma py-1">
          <h1>{des}</h1>
        </div>
      </div>
      <div className="w-full py-5">
        <Sliders />
      </div>
    </section>
  );
};

export default Features;
